export const configFilter = ({ label, permissions, isSkeftoAdmin }) => {
  const {
    home,
    planRegister,
    kpiRegister,
    actionRegister,
    objectiveRegister,
    reporting,
    settings,
    risksRegister
  } = permissions

  if (isSkeftoAdmin) {
    return true
  }

  switch (label) {
    case 'Home': {
      return home
    }
    case 'Plans': {
      return planRegister
    }
    case 'Indicators': {
      return kpiRegister
    }
    case 'Actions': {
      return actionRegister
    }
    case 'Objectives': {
      return objectiveRegister
    }
    case 'Reports': {
      return reporting
    }
    case 'Forms': {
      return risksRegister
    }
    case 'Settings': {
      return settings
    }
  }
}
